import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import notFoundImage from '../assets/404.png'; 

const NotFound = () => {
    return (
        <Container className="text-center d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <Row>
                <Col md={12}>
                    <Image 
                        src={notFoundImage} 
                        alt="404 Not Found" 
                        fluid 
                        style={{ maxWidth: '400px', marginBottom: '30px' }}
                    />
                    <h1 className="display-4 fw-bold">Oops! Trang không tồn tại</h1>
                    <p className="text-muted fs-5">
                        Trang bạn đang tìm kiếm có thể đã bị xóa, đổi tên hoặc tạm thời không khả dụng.
                    </p>
                    <Link to="/">
                        <Button variant="primary" size="lg" className="mt-3">
                            Quay về Trang Chủ
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;
